import React from 'react'
import { Input } from 'sputnik-ui'
import { FormHelperText } from '@material-ui/core'

export default function InputWithError({
  name,
  formik,
  label,
  required,
  ...props
}) {
  const defaultStyles = {
    marginBottom: 5,
    marginTop: 5,
  }
  return (
    <>
      <Input
        required={required}
        name={name}
        value={formik.values[name]}
        onChange={formik.handleChange}
        error={formik.errors && formik.errors[name]}
        label={label}
        fullWidth
        style={{ ...defaultStyles, ...props.style }}
        // style={styles.input}
      />
      {formik.errors && formik.errors[name] && (
        <FormHelperText
          style={{ color: '#FF0E0E', marginLeft: 10, marginBottom: 10 }}
        >
          {formik.errors[name]}
        </FormHelperText>
      )}
    </>
  )
}
